import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useState } from 'react';
import { SCROLL_KEYS } from './use-scroll.constants';
import useEventListener from '../use-event-listener/use-event-listener';

/* eslint-disable getter-return */
export default function useScroll() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    onScroll = _ref.onScroll,
    _ref$once = _ref.once,
    once = _ref$once === void 0 ? false : _ref$once;
  var _useState = useState('wheel'),
    _useState2 = _slicedToArray(_useState, 2),
    wheelEvent = _useState2[0],
    setWheelEvent = _useState2[1];
  var _useState3 = useState({
      passive: false
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    options = _useState4[0],
    setOptions = _useState4[1];
  var preventDefault = useCallback(function (e) {
    e.preventDefault();
  }, []);
  var preventDefaultForScrollKeys = useCallback(function (e) {
    if (SCROLL_KEYS.includes(e.keyCode)) {
      preventDefault(e);
      return false;
    }
    return true;
  }, []);
  function enableScroll() {
    window.removeEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.removeEventListener(wheelEvent, preventDefault, options); // modern desktop
    window.removeEventListener('touchmove', preventDefault, options); // mobile
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
  }
  function disableScroll() {
    window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, options); // modern desktop
    window.addEventListener('touchmove', preventDefault, options); // mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false);
  }
  function enableBodyScroll() {
    document.body.style.overflow = '';
  }
  function disableBodyScroll() {
    document.body.style.overflow = 'hidden';
  }
  function hideTabBar() {
    window.scrollTo(0, window.scrollY + 1);
  }
  useEffect(function () {
    // modern Chrome requires { passive: false } when adding event
    var supportsPassive = false;
    try {
      window.addEventListener('check', null, Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassive = true;
        }
      }));
    } catch (e) {
      supportsPassive = false;
    }
    setOptions(supportsPassive ? {
      passive: false
    } : false);
    setWheelEvent('onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel');
    return function () {
      enableScroll();
      enableBodyScroll();
    };
  }, []);
  useEventListener('scroll', onScroll, {
    once: once
  });
  return {
    disableScroll: disableScroll,
    enableScroll: enableScroll,
    enableBodyScroll: enableBodyScroll,
    disableBodyScroll: disableBodyScroll,
    hideTabBar: hideTabBar
  };
}